import React from 'react';
import PropTypes from 'prop-types';

export const Fields = ({ width, height, ...props }) => (
  <svg
    data-icon='fields'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M4 18h4V6H4v12Zm6 0h4V6h-4v12Zm6 0h4V6h-4v12ZM4 20c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 2 18V6c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 4 4h16c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412v12c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 20 20H4Z'
    />
  </svg>
);

Fields.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Fields.defaultProps = {
  width: 24,
  height: 24,
};
